import * as React from 'react'
import InputField from 'app/shared/components/InputField'
import { useValidation } from 'app/shared/hooks/validation/validation.hook'

const PgValidation: React.FC = () => {
    const [input1, setInput1] = React.useState('')
    const { errorInfo: errorInfoInput1, validate: validateInput1 } =
        useValidation({
            value: input1,
            type: 'Number',
            message: '숫자만 입력해주세요',
        })

    const [input2, setInput2] = React.useState('')
    const { errorInfo: errorInfoInput2, validate: validateInput2 } =
        useValidation({
            value: input2,
            type: 'String',
            message: '문자만 입력해주세요',
        })
    const [input3, setInput3] = React.useState('')
    const { errorInfo: errorInfoInput3, validate: validateInput3 } =
        useValidation({
            value: input3,
            type: 'Email',
            message: '이메일 똑바로 입력해주세요',
        })
    const [input4, setInput4] = React.useState('')
    const { errorInfo: errorInfoInput4, validate: validateInput4 } =
        useValidation({
            value: input4,
            type: 'TEL',
            message: '전화번호 형식이 아닙니다',
        })
    const [input5, setInput5] = React.useState('')
    const { errorInfo: errorInfoInput5, validate: validateInput5 } =
        useValidation({
            value: input5,
            type: 'Korean',
            message: '한글만 입력해주세요',
        })

    /** 커스텀 */
    const [input6, setInput6] = React.useState('')
    const { errorInfo: errorInfoInput6, validate: validateInput6 } =
        useValidation({
            value: input6,
            type: 'Custom',
            customFn: (value) => {
                if (value.length === 0) return '입력해주세요'
                if (value.length > 10) return '10글자이상 ㄴㄴ'
                if (value.length < 5) return '최소 5글자입니다'

                return ''
            },
        })

    return (
        <>
            <h1>PgValidation</h1>
            <br />
            <InputField
                value={input1}
                onChange={(e) => setInput1(e.target.value)}
                onClear={() => {
                    setInput1('')
                }}
                placeholder="숫자만 입력해주세요"
                title="숫자"
                resultId="input1-result"
                onBlur={() => validateInput1()}
                {...errorInfoInput1}
            />
            <br />
            <InputField
                value={input2}
                onChange={(e) => setInput2(e.target.value)}
                onClear={() => setInput2('')}
                placeholder="문자만 입력해주세요"
                title="문자"
                onBlur={() => validateInput2()}
                {...errorInfoInput2}
            />
            <br />
            <InputField
                value={input3}
                onChange={(e) => setInput3(e.target.value)}
                onClear={() => setInput3('')}
                placeholder="이메일"
                title="이메일"
                onBlur={() => validateInput3()}
                {...errorInfoInput3}
            />{' '}
            <br />
            <InputField
                value={input4}
                onChange={(e) => setInput4(e.target.value)}
                onClear={() => setInput4('')}
                placeholder="전화/휴대폰번호"
                title="전화/휴대폰번호"
                onBlur={() => validateInput4()}
                {...errorInfoInput4}
            />{' '}
            <br />
            <InputField
                value={input5}
                onChange={(e) => setInput5(e.target.value)}
                onClear={() => setInput5('')}
                placeholder="한글"
                title="한글"
                onBlur={() => validateInput5()}
                {...errorInfoInput5}
            />
            <br />
            <InputField
                value={input6}
                onChange={(e) => setInput6(e.target.value)}
                onClear={() => setInput6('')}
                placeholder="커스텀"
                title="커스텀"
                onBlur={() => validateInput6()}
                {...errorInfoInput6}
            />
        </>
    )
}
export default PgValidation
